import {
    cloneElement,
    type FC
} from "react";
import type {
    GestureResponderEvent
} from "react-native";
import type ISheetCloseProps from "./type";
import {
    useSheetContext
} from "../../context";

const SheetClose: FC<ISheetCloseProps> = ({
    children,
    style
}) => {
    const sheet = useSheetContext({
        part: "Close"
    });

    if(!sheet) {
        return children;
    }

    const onPress = (event: GestureResponderEvent) => {
        if(children.props.onPress) children.props.onPress(event);

        sheet.requestClose();
    };

    return cloneElement(children, {
        style: style ? [
            children.props.style,
            style
        ] : children.props.style,
        onPress
    });
};
export default SheetClose;
